/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EtcCardHolder } from './etc-card-holder';
// May contain unused imports in some cases
// @ts-ignore
import { EtcCardUserAccountGroup } from './etc-card-user-account-group';

/**
 * 
 * @export
 * @interface EtcCard
 */
export interface EtcCard {
    /**
     * ETC card ID
     * @type {string}
     * @memberof EtcCard
     */
    'cardId': string;
    /**
     * Card name (max 64 characters)
     * @type {string}
     * @memberof EtcCard
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof EtcCard
     */
    'cardStatus': EtcCardCardStatusEnum;
    /**
     * 
     * @type {EtcCardHolder}
     * @memberof EtcCard
     */
    'holder': EtcCardHolder;
    /**
     * 
     * @type {EtcCardUserAccountGroup}
     * @memberof EtcCard
     */
    'userAccountGroup'?: EtcCardUserAccountGroup | null;
    /**
     * User account ID
     * @type {string}
     * @memberof EtcCard
     */
    'userAccountId': string;
    /**
     * Last four digits of the ETC card ID for display
     * @type {string}
     * @memberof EtcCard
     */
    'etcIdLastFourDigits'?: string | null;
}

export const EtcCardCardStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type EtcCardCardStatusEnum = typeof EtcCardCardStatusEnum[keyof typeof EtcCardCardStatusEnum];


